import View from './view';

export const Welcome = View;
